import React from 'react';
import * as UI from '../styles/ui';

/**
 * The one empty state used across the app (ui-rules §9): text centred, 13px
 * gray-500, an optional action centred under it.
 *
 *   <EmptyState text="No approvals waiting for you right now." onRefresh={load} />
 *   <EmptyState flat text="No runs yet." />            // inside an existing card
 *   <EmptyRow colSpan={6} text="No parties match." />  // inside a <tbody>
 */
const EmptyState: React.FC<{
  text: React.ReactNode;
  onRefresh?: () => void;
  action?: React.ReactNode;
  flat?: boolean;
}> = ({ text, onRefresh, action, flat }) => (
  <div style={flat ? UI.emptyFlat : UI.empty}>
    <span>{text}</span>
    {onRefresh && <button type="button" style={UI.btn} onClick={onRefresh}>↻ Refresh</button>}
    {action}
  </div>
);

export const EmptyRow: React.FC<{ colSpan: number; text: React.ReactNode }> = ({ colSpan, text }) => (
  <tr><td colSpan={colSpan} style={UI.emptyCell}>{text}</td></tr>
);

export default EmptyState;
